module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJwcmVmaXhfX2ljX3NtYWxsX2NpcmNsZV90aWNrX2luYWN0aXZlIiB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiI+CiAgICA8Y2lyY2xlIGlkPSJwcmVmaXhfX0VsbGlwc2VfNTYiIGN4PSIxMSIgY3k9IjExIiByPSIxMSIgZGF0YS1uYW1lPSJFbGxpcHNlIDU2IiBzdHlsZT0iZmlsbDojYjZjMmM3O29wYWNpdHk6LjI4MyIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./static/pw/tick_inactive.svg
// module id = 238
// module chunks = 1